import React from 'react';

import { tokens } from '../../../core/theming/tokens';

type Props = {
  // Mostrar el wordmark "Yieldbox · Consola" al lado del monograma.
  wordmark?: boolean;
  // Lado del tile del monograma en px.
  size?: number;
};

// Monograma de marca: una "Y" geometrica (evoca el trazo Aventa) dentro de un
// tile sobrio. Marfil sobre oscuro, hairline de marca. Sin dependencias de logo
// rasterizado: vectorial y nitido a cualquier escala.
export function BrandGlyph({ size = 34 }: { size?: number }) {
  let r = Math.round(size * 0.26);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect
        x="0.6"
        y="0.6"
        width="36.8"
        height="36.8"
        rx={r}
        fill={tokens.card2}
        stroke={tokens.lineStrong}
        strokeWidth="1.2"
      />
      <path
        d="M12 11.5 L19 20 L26 11.5"
        stroke={tokens.text}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 20 L19 27.5"
        stroke={tokens.text}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function BrandMark({ wordmark = true, size = 34 }: Props) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <BrandGlyph size={size} />
      {wordmark && (
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
          <span
            style={{
              color: tokens.text,
              fontSize: 17,
              fontWeight: 600,
              letterSpacing: 0.2,
            }}
          >
            Yieldbox
          </span>
          <span
            style={{
              color: tokens.faint,
              fontSize: 10,
              fontWeight: 500,
              letterSpacing: 2.4,
              textTransform: 'uppercase',
              marginTop: 4,
            }}
          >
            Consola
          </span>
        </div>
      )}
    </div>
  );
}
